export const menuData = [
    { title: "About", link: "/about" },
    { title: "Homes", link: "/homes" },
    { title: "Rentals", link: "/reantals" },
];